// src/services/device-trust.js
// Le jeton « se souvenir de cet appareil 30 jours ».
//
// Il vit dans `localStorage` et non dans un cookie : l'API s'authentifie en Bearer et n'a
// aucune session à cookie. En introduire un pour ce seul usage obligerait à traiter le CSRF
// sur tout le reste.
//
// Ce jeton n'est PAS un jeton d'accès. Seul, il ne donne rien : il dispense du second facteur
// une fois le mot de passe fourni, et rien d'autre. Le serveur vérifie en outre qu'il
// appartient bien au compte qui tente d'entrer.
//
// 🔴 Une clé par TYPE de compte. Sur un poste partagé — le cas courant chez un installateur —
// l'administrateur et le client ne doivent pas s'écraser mutuellement leur mémorisation.
const CLE = type => `ior:trust:${type === 'admin' ? 'admin' : 'client'}`;

export function lire(type) {
  try { return localStorage.getItem(CLE(type)) || null; } catch (e) { return null; }
}

export function poser(type, jeton) {
  try { if (jeton) localStorage.setItem(CLE(type), jeton); } catch (e) { /* navigation privée */ }
}

// Appelé quand le serveur cesse de reconnaître l'appareil — jeton révoqué depuis le profil,
// ou second facteur réinitialisé. Garder un jeton mort ne casse rien, mais il traîne.
export function oublier(type) {
  try { localStorage.removeItem(CLE(type)); } catch (e) { /* ignoré */ }
}

export default { lire, poser, oublier };
